import { Button, Image, Result, Spin } from "antd";
import { ErrorMessage, Field, Form, Formik } from "formik";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import * as Yup from "yup";
import Logo from "../../assets/images/logo_WasteNoFood_header.gif";
import { API } from "../../config/api";
import { PostAPIRequest } from "../../services/api";
function LocalAdminSetPassword({ history }) {
  const TokenStatus = {
    Validating: "Validating",
    Valid: "Valid",
    Invalid: "Invalid",
    Success: "Success",
    Used: "Used",
  };

  const [token, setToken] = useState(null);
  const [tokenStatus, setTokenStatus] = useState(TokenStatus.Validating);

  useEffect(() => {
    const { token, type } = queryString.parse(window.location.search);

    // remove token from url to prevent http referer leakage
    // history.replace(window.location.pathname);
    PostAPIRequest({
      url: API.validateResetToken,
      data: {
        token: token,
        user_type: type,
      },
    })
      .then((response) => {
        console.log("Request Successful!", response);
        if (response.status === "success") {
          setToken(token);
          setTokenStatus(TokenStatus.Valid);
        } else if (response.status === "used") {
          setTokenStatus(TokenStatus.Used);
        } else {
          alert(response.message);
          setTokenStatus(TokenStatus.Invalid);
        }
      })
      .catch((error) => {
        console.error("Request Failed:", error);
        setTokenStatus(TokenStatus.Invalid);
      });
  }, []);

  function getForm() {
    const initialValues = {
      password: "",
      confirmPassword: "",
    };

    const validationSchema = Yup.object().shape({
      password: Yup.string()
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    });

    function onSubmit({ password, confirmPassword }, { setSubmitting }) {
      const { type } = queryString.parse(window.location.search);
      PostAPIRequest({
        url: API.updatePassword,
        data: {
          token: token,
          password: password,
          confirmPassword: confirmPassword,
          user_type: type,
        },
      })
        .then((response) => {
          console.log("Request Successful!", response);

          if (response.status === "success") {
            setTokenStatus(TokenStatus.Success);
          } else {
            setSubmitting(false);
            alert(response.message);
          }
        })
        .catch((error) => {
          setSubmitting(false);
          alert("Oops! Something went wrong. Please try again later.");
        });
    }

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ errors, touched, isSubmitting }) => (
          <Form>
            <div className="form-group">
              <label>Password</label>
              <Field
                name="password"
                type="password"
                className={
                  "form-control" +
                  (errors.password && touched.password ? " is-invalid" : "")
                }
              />
              <ErrorMessage
                name="password"
                component="div"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <Field
                name="confirmPassword"
                type="password"
                className={
                  "form-control" +
                  (errors.confirmPassword && touched.confirmPassword
                    ? " is-invalid"
                    : "")
                }
              />
              <ErrorMessage
                name="confirmPassword"
                component="div"
                className="invalid-feedback"
              />
            </div>
            <div className="form-row">
              <div className="form-group col" style={{ textAlign: "right" }}>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-primary"
                >
                  {isSubmitting && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                  )}
                  Reset Password
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }

  function getBody() {
    switch (tokenStatus) {
      case TokenStatus.Valid:
        return getForm();
      case TokenStatus.Used:
        return (
          <Result
            status="500"
            title="Token already used!"
            subTitle="This token has been already used."
          />
        );
      case TokenStatus.Invalid:
        return (
          <Result
            status="500"
            title="Token validation failed!"
            subTitle="Token validation failed, if the token has expired you can get a new
            one at the forgot password page."
          />
        );

      case TokenStatus.Validating:
        return <Spin size="large" />;
      case TokenStatus.Success:
        return (
          <Result
            status="success"
            title="Thank You!"
            subTitle="You account has been setup, you can login now!"
            extra={[
              <Button
                type="primary"
                key="console"
                onClick={() => {
                  if (isMobile) {
                    window.open("wastenofood://com.app.wnf");
                  } else {
                    window.open("https://admin.wastenofood.org");
                  }
                }}
              >
                Continue
              </Button>,
            ]}
          />
        );
    }
  }

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "90%",
          maxWidth: 500,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image style={{ marginTop: 40, marginBottom: 30 }} src={Logo} />
        <div
          style={{
            alignSelf: "stretch",
            marginTop: 40,
            marginBottom: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {getBody()}
        </div>
      </div>
    </div>
  );
}

export default LocalAdminSetPassword;
